import React, { ReactElement } from 'react'
// Commons imports.
import ExpansionPanel, { ExpansionPanelItem } from '../../Common/Components/ExpansionPanel'
// CSS imports. Commented out because of current build process.
// import './BulkInsertExpansionPanel.scss';

/**
 * Component properties type.
 *
 * @param expansionPanelItems a list of panel items to be generated.
 */
type Props = {
    expansionPanelItems: ExpansionPanelItem[]
}

/**
 * Bulk Insert Expansion panel component.
 *
 * @param expansionPanelItems List of expansion panel items.
 */
const BulkInsertExpansionPanel: React.FC<Props> = ({ expansionPanelItems }: Props): ReactElement => (
    <div className='cBulkInsertExpansionPanel'>
        <ExpansionPanel expansionPanelItems={expansionPanelItems} />
    </div>
)

export default BulkInsertExpansionPanel
